<template v-if="loaded">
    <tr v-if="isEqual(o,n)">
        <td style="padding: 0 5px;"></td>
        <td style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td valign="top">{{ strip_tags(prefix) }}</td>
                    <td width="100%">
                        <div class="textarea" style="background-color: transparent">
                            <span class="comma"><span v-for="row in res" track-by="$index">{{ getOptionName(row)  }}</span></span>
                        </div>
                    </td>
                    <td valign="top">{{ strip_tags(prefix) }}</td>
                </tr>
            </table>
        </td>
        <td style="padding: 0 5px;"></td>
    </tr>
    <tr v-else>
        <td :class="{'selected': isEqual(o, res)}" style="padding: 0 5px;" valign="top">
            <a @click="cloneArrToRes(o)">
                <span class="comma">
                    <span v-for="row in o" track-by="$index">{{ getOptionName(row)  }}</span>
                </span>
                <i v-if="(o == []) || (o == '') || (o == null) || (o.length == 0)">✕</i>
            </a>
        </td>
        <td class="selected" style="padding: 0 5px;" valign="top">
            <table style="width: 100%">
                <tr>
                    <td valign="top">{{ prefix }}</td>
                    <td width="100%">
                        <div class="textarea" style="background-color: transparent">
                            <span class="comma">
                                <span v-for="row in res" track-by="$index">{{ getOptionName(row) }}</span>
                            </span>
                        </div>
                    </td>
                    <td valign="top">{{ suffix }}</td>
                </tr>
            </table>
        </td>
        <td :class="{'selected': isEqual(n,res)}" style="padding: 0 5px;" valign="top">
            <a @click="cloneArrToRes(n)">
                <span class="comma"><span v-for="row in n" track-by="$index">{{ getOptionName(row) }}</span></span>
                <i v-if="(n == []) || (n == '') || (n == null) || (n.length == 0)">✕</i>
            </a>
        </td>
    </tr>
</template>
<script>

import Base from "../Base.vue";
export default {
    mixins:[Base],
    props: {
        o: {
            type: Array,
            default: []
        },
        n: {
            type: Array,
            default: []
        },
        f: {
            type: Array,
            default: []
        },
        prefix: {
            type: String,
            default: ''
        },
        suffix: {
            type: String,
            default: ''
        },
        field: {
            type: String,
            default: 'text'
        },
    },
    computed:{
      loaded: function (){
          return this.options.length > 0;
      },
      optionsComputed: function (){
          if (this.storedItem === null){
              return this.options;
          }
          return this.getDict(this.storedItem)
      }
    },
    created() {
        this.cloneArrToRes(this.res);
    },
    methods: {
        getOptionName: function (id){
                if (this.optionsComputed.length === 0){
                    return '';
                }
            return (this.optionsComputed.find(o => o.value ===  '' + id)[this.field])
        }
    },
}
</script>
